// extracted by mini-css-extract-plugin
export default {"price":"PZ-z","onSale":"QZ-z","msrpLabelPrice":"RZ-z","originalPrice":"SZ-z","msrpLabel":"TZ-z","percentOff":"UZ-z"};